import { GetCustomerPaymentMethodsDocument } from "@/core/api/graphql/types";
import { globals } from "@/core/globals";
import { graphqlClient } from "../../../client";
import type {
  GetCustomerPaymentInstrumentsRequestResultType,
  Query,
  QueryGetCustomerPaymentMethodsArgs,
} from "@/core/api/graphql/types";

export async function getCustomerPaymentMethods(
  customerId: string,
  dataAreaId: string,
): Promise<GetCustomerPaymentInstrumentsRequestResultType> {
  const { userId } = globals;

  const { data } = await graphqlClient.query<
    Required<Pick<Query, "getCustomerPaymentMethods">>,
    QueryGetCustomerPaymentMethodsArgs
  >({
    query: GetCustomerPaymentMethodsDocument,
    variables: {
      userId,
      memberId: customerId,
      dataAreaId: dataAreaId,
      storeId: globals.storeId,
    },
  });

  return data.getCustomerPaymentMethods;
}
